import i18next from "i18next";
import Backend from "i18next-http-backend"; // Load translations from separate files
import locI18next from "loc-i18next";

let localize; // Declare 'localize' in the outer scope to make it accessible

const i18nextInit = async () => {
	await i18next
		.use(Backend)
		.init({
			debug: false,
			lng: document.querySelector("meta[name=\"site-language\"]")?.getAttribute("content") || "en", // Pull the language from the meta tag
			fallbackLng: false, // Show the key if the desired translation is not defined

			parseMissingKeyHandler: (key) => key + " (Not Found)", // Format for missing keys

			/* handle missing keys i.e. call webhook etc. example:
			saveMissing: true,
			missingKeyHandler: function(lng, ns, key, res) {
				console.warn(`Missing LCB Translation: [${lng}] [${ns}] ${key}`);
			},
			*/

			ns: ["translation"],
			defaultNS: "translation",
			interpolation: { escapeValue: false }, // Do not escape special characters
			backend: {
				loadPath: '/GlobalIncludes/Interface/Includes/i18next_locales/frontend/{{lng}}/{{ns}}.json?' + document.querySelector('meta[name="release-id"]').content,
			},
		});

	// Initialize loc-i18next after i18next is ready
	localize = locI18next.init(i18next, {
		selectorAttr: "data-i18n",           // Attribute used to identify elements to translate
		targetAttr: "data-i18n-target",      // Attribute specifying the target attribute for translation: i.e. <div data-i18n="key" data-i18n-target=".phone"><span class=".phone"></span></div>
		optionsAttr: "data-i18n-options",    // Attribute containing JSON options for translation, such as interpolation values: i.e. <p data-i18n="key" data-i18n-options="{1: 'i18next', 2: 'Jean-François'}"></p>
		useOptionsAttr: true,                // Allow the use of i18next options specified in 'optionsAttr': this will be needed in order to pass interpolation values
		parseDefaultValueFromContent: false, // Use element's content as default value if translation is missing
		//document: window.document            // Document context to operate within
	});

	console.log("i18next has been initialized!");
};

// Export 'i18next' objects and the initialization function
export { i18nextInit,  localize };
export {default as i18next} from "i18next";
